import React from 'react';
import { useNavigate, useNavigationType, useRoutes } from 'react-router-dom';
import { useAppContext } from './AppProvider';
import routes from './utils/routes';

const canRedirectHome = (pathname, historyAction) => {
  if (!pathname || window.location.search !== '') {
    return false;
  }
  if (window.location.search !== '' && historyAction === 'PUSH') {
    return true;
  }
  if (historyAction === 'POP') {
    return true;
  }
  return false;
};

const ProtectedRoute = () => {
  const { state: { client } } = useAppContext();
  const historyAction = useNavigationType();
  const navigate = useNavigate();
  const isLogged = Object.keys(client).length > 0;
  const rounting = useRoutes(routes(isLogged));

  // eslint-disable-next-line
  const redirect = () => {
    const locationPathName = window.location.pathname;
    if (canRedirectHome(locationPathName, historyAction)) {
      return navigate('/comprar/seguro-salud-flexible');
    }
    return null;
  };

  return (
    <div>
      {redirect()}
      {rounting}
    </div>
  );
};

export default ProtectedRoute;
